



import CampaignIcon from "@mui/icons-material/Campaign";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FilterListIcon from "@mui/icons-material/FilterList";
import InstagramIcon from "@mui/icons-material/Instagram";
import axios from "axios";
import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import InfluencerHeader from "./InfluencerHeader";
import Navbar from "./Navbar";
// influencer-marketing-FE/src/App.js or index.jss
import '../../App.css';

const parseFollowerRange = (range) => {
  const [min, max] = range.map(Number);
  return { min, max };
};

const InfluencerHistory = () => {
  const [search, setSearch] = useState("");
  const [filterType, setFilterType] = useState("all");
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [campaignsPerPage, setCampaignsPerPage] = useState(6);
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const influencerId = localStorage.getItem("influencerID");
  const navigate = useNavigate();

  const getCampaigns = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        "https://server-side-influencer.onrender.com/brand/getAllCampaigns"
      );
      setCampaigns(res.data.data);
      setLoading(false);
      setInitialLoadComplete(true);
    } catch (error) {
      console.error("Failed to fetch campaigns", error);
      setLoading(false);
      setInitialLoadComplete(true);
    }
  };

  useEffect(() => {
    getCampaigns();
    const handleResize = () => {
      setCampaignsPerPage(window.innerWidth >= 1024 ? 6 : 2);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLikeToggle = async (event, campaignId) => {
    event.stopPropagation();
    if (!influencerId) {
      toast.error("Influencer ID is missing.");
      return;
    }
    try {
      const response = await axios.post(
        "https://server-side-influencer.onrender.com/influencer/updateLike",
        {
          userId: influencerId,
          campaignId: campaignId,
        }
      );
      response.data.success
        ? toast.success(response.data.message || "Updated like status.")
        : toast.error(response.data.message || "Failed to update like.");
      getCampaigns();
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to update like.");
    }
  };

  const isLikedByInfluencer = (campaign) => {
    return campaign.likes && influencerId && campaign.likes.includes(influencerId);
  };




  
    useEffect(() => {
      const handleResize = () => {
        setIsSmallScreen(window.innerWidth <= 760);
      };
  
      handleResize();
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
  
  const handleCardClick = (campaign) => {
    if (!influencerId) {
      toast.error("Influencer ID is missing.");
      return;
    }
    axios
      .post("https://server-side-influencer.onrender.com/influencer/updateReach", {
        campaignId: campaign._id,
        userId: influencerId,
      })
      .then((response) => {
        navigate("/campaigndetails", { state: { campaignDetails: campaign } });
      })
      .catch((error) => {
        toast.error("Failed to update reach.");
      });
  };

  const filterByType = (campaign) => {
    const { min, max } = parseFollowerRange(campaign.followerRange);
    if (filterType === "micro") return max <= 100000;
    if (filterType === "nano") return min > 100000 && max <= 500000;
    if (filterType === "mega") return min > 500000;
    return true;
  };

  const filteredCampaigns = campaigns
    .filter((c) => c.campaignName.toLowerCase().includes(search.toLowerCase()))
    .filter(filterByType);

  const indexOfLastCampaign = currentPage * campaignsPerPage;
  const indexOfFirstCampaign = indexOfLastCampaign - campaignsPerPage;
  const currentCampaigns = filteredCampaigns.slice(indexOfFirstCampaign, indexOfLastCampaign);
  const totalPages = Math.ceil(filteredCampaigns.length / campaignsPerPage);

  return (
    <div className="flex h-screen hide-scrollbar " style={{
    marginLeft: isSmallScreen ? '0px' : '72px'}}>
      <div className="fixed top-0 left-0 right-0 z-40 bg-white shadow-md">
        <InfluencerHeader page="Campaigns" />
      </div>
      <div className="text-white fixed top-0 left-0 bottom-0 z-50">
        <Navbar />
      </div>

      <div className="flex-1 p-6 mt-12 "   style={{
    marginLeft: isSmallScreen ? '0px' : '3px'}}>
        <div className="flex justify-center items-center gap-2 mb-6">
          <CampaignIcon className="text-purple-600" style={{ fontSize: 40 }} />
          <h2 className="text-xl font-extrabold text-gray-800 text-center mt-5 mb-10">
            Find Your Perfect Brand Partnership in These Campaigns!
          </h2>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
          <input
            type="text"
            placeholder="Search campaigns..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full max-w-md px-5 py-3 border border-gray-300 rounded-full shadow-md focus:outline-none focus:ring-2 focus:ring-pink-400"
          />
          <div className="flex items-center gap-2">
            <FilterListIcon className="text-gray-600" />
            <select
              value={filterType}
              onChange={(e) => setFilterType(e.target.value)}
              className="px-4 py-2 border border-gray-300 rounded-full shadow-md focus:outline-none focus:ring-2 focus:ring-purple-400"
            >
              <option value="all">All</option>
              <option value="micro">Micro (≤ 100K)</option>
              <option value="nano">Nano (100K - 500K)</option>
              <option value="mega">Mega (500K+)</option>
            </select>
          </div>
        </div>


        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {(!initialLoadComplete ? Array.from({ length: campaignsPerPage }) : currentCampaigns).map(
            (campaign, index) => (
              <div
                key={index}
                className="relative max-w-[600px] h-[380px] bg-white rounded-3xl shadow-lg overflow-hidden hover:shadow-2xl transition duration-300 mb-4"
                onClick={() => handleCardClick(campaign)}
              >
                <div className="h-1/2 bg-gray-200 relative">
                  {!initialLoadComplete ? (
                    <Skeleton height="100%" />
                  ) : (
                    <div
                      className="w-full bg-center"
                      onClick={() => handleCardClick(campaign)}
                      style={{
                        height: isSmallScreen ? '190px' : '190px',
                        backgroundImage: `url(${campaign.campaignImages[0]})`,
                        backgroundSize: '100% 100%',
                        backgroundRepeat: 'no-repeat'
                      }}
                    >
                      <div className="absolute inset-0 bg-black/30" />
                      <div className="absolute top-2 right-2 z-10 text-white cursor-pointer">
                        <div
                          onClick={(event) => handleLikeToggle(event, campaign._id)}
                          className="flex flex-col items-center"
                        >
                          {isLikedByInfluencer(campaign) ? (
                            <FavoriteIcon style={{ fontSize: 40, color: "red" }} />
                          ) : (
                            <FavoriteBorderIcon style={{ fontSize: 40, color: "white" }} />
                          )}
                          <span className="text-sm font-medium mt-1">
                            {campaign.likesCount || 0}
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div className="absolute left-4 top-[47%] z-0 transform translate-y-1/2 flex items-center">
                  {!initialLoadComplete ? (
                    <Skeleton circle width={56} height={56} />
                  ) : (
                    <img
                 src={campaign.profilePic || "https://i.postimg.cc/brqZVdrP/dummypic.jpg"}
                      alt="Profile"
                      className="w-14 h-14 rounded-full border-2 border-white shadow-md bg-white"
                    />
                  )}
                  {!initialLoadComplete ? (
                    <Skeleton width={120} />
                  ) : (
                    <h3 className="ml-3 text-lg font-bold text-gray-800">
                      {campaign.brandName}
                    </h3>
                  )}
                </div>

                <div className="p-4 pt-6 flex flex-col gap-2 relative h-1/2 mt-4">
                  <h3 className="text-lg font-bold text-gray-800 mt-8 text-center">
                    {!initialLoadComplete ? <Skeleton width={120} /> : campaign.campaignName}
                  </h3>
                  <div className="flex items-center text-sm text-gray-600 mt-1">
                    {!initialLoadComplete ? (
                      <Skeleton width={80} />
                    ) : (
                      <>
                        <InstagramIcon className="text-pink-500 mr-2" style={{ fontSize: 20 }} />
                        {campaign.followerRange[0]} - {campaign.followerRange[1]}
                      </>
                    )}
                  </div>
                </div>
              </div>
            )
          )}
        </div>


        {/* Paginationsss */}
        {totalPages > 1 && (
          <div className="flex justify-center items-center gap-4 mt-8">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              className="px-4 py-2 bg-gray-200 text-black rounded-lg disabled:opacity-50"
            >
              Prev
            </button>
            <span className="text-sm font-medium">Page {currentPage} of {totalPages}</span>
            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
              className="px-4 py-2 bg-gray-200 text-black rounded-lg disabled:opacity-50"
            >
              Next
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default InfluencerHistory;